export default __webpack_public_path__ + "f3a278275a248e11cc4090dd08adffd9.png";